import React from "react";
import { useTranslation } from "react-i18next";

interface FilesUploadedProps {
  uploadedCount?: number;
}

export const FilesUploaded: React.FC<FilesUploadedProps> = ({ uploadedCount }) => {
  const { t } = useTranslation();

  return (
    <div className="py-5 px-6 border-b border-gray-200 flex items-center gap-2">
      <p>{t("Files uploaded")}</p>
      <div className="bg-ominimo-100 text-ominimo-400 rounded px-[10px] py-[5px] font-medium text-[16px] leading-[16px]">
        {uploadedCount}/5
      </div>
    </div>
  );
};
